import { map } from 'rxjs';
import { Injectable } from '@angular/core';
import { UsuarioRepository } from '@data/usuario/usuario.repository';
import { PatchUsuarioDto } from '@data/usuario/dto';
import { AuthService } from '@infra/auth/auth.service';

@Injectable()
export class MinhaContaController {
  constructor(
    private usuarioRepository: UsuarioRepository,
    private authService: AuthService,
  ) {}

  atualizarUsuario(data: PatchUsuarioDto) {
    return this.usuarioRepository.patch(data).pipe(
      map((response) => {
        // Se o usuário alterou a senha, atualiza o primeiroAcesso para 'N'
        if(data.senha) {
          this.authService.primeiroAcesso = 'N';
        }

        return response;
      }),
    );
  }
}
